module.exports = __webpack_public_path__ + "69f0dd3d44ca87f44e53f46489303dbc.png";